module.exports = __webpack_public_path__ + "static/img/6.9469a16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/6.jpg
// module id = mbtb
// module chunks = 15